// Don't use `rem` units for anything since existing CSS `font-size` affects all rem units
// https://github.com/am-systems/am-web-properties/blob/c1d44502a5babfe955a7f7462eba23658a73bbe3/public/thecreditreview/css/top-services/media-query.css#L22-L25.
// Existing `rem` units are migrated values from old styles to avoid breaking layouts.
export const getStyles = () => ({
	featuredCompanyHeader: {
		wrapper:
			"tw-bg-[#EDF4FE] tw-text-center tw-text-balance tw-rounded-t-[3px] tw-py-[8px] tw-px-[20px]",
		contentWrapper:
			"tw-text-[#333641] tw-font-semibold tw-leading-[24px] tw-text-[16px] tw-tracking-[-0.16px]",
	},
	serviceFlag: {
		wrapper:
			"tw-absolute tw-top-[16px] tw-left-[-8px] tw-flex desktop:tw-top-[24px]",
		flag: `tw-w-[28px] tw-h-[28px] tw-bg-[#0D8AE3] tw-flex tw-items-center tw-justify-center tw-rounded-[3px]`,
		number:
			"tw-text-white tw-text-[12px] tw-m-0 tw-pt-[2px] tw-font-semibold tw-leading-[16px]",
		text: "tw-relative tw-ml-[2px] tw-h-[28px] tw-rounded-[3px] tw-pl-[8px] tw-pt-[7px] tw-pb-[5px] tw-flex tw-items-center tw-justify-center tw-bg-[#0D8AE3] tw-text-white tw-text-[12px] tw-font-semibold tw-leading-[16px] after:tw-relative after:tw-left-[6px] after:tw-top-[-1px] after:tw-w-[16px] after:tw-h-[28px] after:[border-right:10px_solid_white] after:[border-top:14px_solid_#0D8AE3] after:[border-bottom:14px_solid_#0D8AE3] ",
	},
	companyLogo: {
		picture: "tw-max-w-[200px]",
		image: "tw-max-w-full",
	},
	trustpilotReview: {
		container: "tw-flex tw-flex-col tw-text-right desktop:tw-text-center",
		reviewCount:
			"tw-text-[#232227] tw-text-[13px] tw-leading-[16px] xs2:tw-text-[14px]",
		reviewCountNumber: "tw-font-bold [font-family:Graphik_Web]",
		reviewCountText: "tw-ml-[2px]",
		ratingContainer:
			"tw-my-[6px] tw-flex tw-gap-[3px] tw-justify-end xs2:tw-my-[8px]",
		starBase:
			"tw-relative tw-rounded-[3px] tw-w-[20px] tw-h-[20px] tw-flex tw-items-center tw-justify-center tw-text-white tw-text-[12px] xs2:tw-text-[14px] xs2:tw-w-[24px] xs2:tw-h-[24px]",
		ratingCountWrapper:
			"tw-w-full tw-flex tw-items-end tw-gap-[2px] tw-justify-evenly tw-text-[13px] tw-text-[#232227] tw-leading-[13px] xs2:tw-text-[14px] xs2:tw-leading-[14px]",
		ratingCount: "tw-font-bold [font-family:Graphik_Web]",
		ratingCountText: "",
		trustPilotLogo: "tw-h-[16px] tw-w-auto",
	},
	columnInformation: {
		wrapper: "tw-grid tw-gap-[8px] desktop:tw-flex",
		columnWrapper:
			"tw-p-[8px] tw-w-full tw-flex tw-items-center tw-gap-[8px] tw-shadow-[0px_5px_32px_0px_rgba(0,0,0,0.04),0px_10px_64px_0px_rgba(50,50,93,0.06)] tw-rounded-[3px] tw-border-solid tw-border-[#D6DBDF] xs2:tw-p-[12px] xs2:tw-gap-[12px] desktop:tw-w-fit",
		column: "",
		icon: "tw-w-[24px] tw-h-[24px] xs:tw-w-[32px] xs:tw-h-[32px]",
		label:
			"tw-mb-[4px] tw-font-[Montserrat] tw-text-[12px] tw-text-[#787E81] tw-uppercase tw-font-semibold tw-leading-[16px] xs2:tw-mb-[6px]",
		value:
			"tw-text-[16px] [font-family:Graphik_Web] tw-leading-[20px] tw-font-semibold tw-text-[#48484B]",
	},
	mobileSocialProof: {
		wrapper: "tw-flex tw-mt-[8px] tw-justify-center desktop:tw-hidden",
		contentWrapper: "tw-flex tw-items-center tw-gap-[8px]",
		contentIcon: "tw-text-[#0D8AE3] tw-text-[20px]",
		content:
			"tw-leading-[12px] tw-font-semibold tw-text-[12px] tw-text-[#232227] tw-pt-[4px] tw-m-0",
	},
	benefitsList: {
		wrapper: "tw-w-full",
		list: "tw-m-0 tw-max-w-full tw-flex tw-flex-col xs2:tw-w-[500px] desktop:tw-w-full",
		listItem:
			"tw-mb-[8px] tw-text-pretty tw-mx-0 tw-pl-[25px] tw-text-[#48484B] tw-font-semibold tw-text-[16px] tw-leading-[24px] tw-bg-[url(/public/react-images/common/iconTick.svg)] tw-bg-no-repeat tw-bg-[left_top_5px] last:tw-mb-0",
		expandButton:
			"tw-w-full tw-flex tw-cursor-pointer tw-items-center tw-border-0 tw-bg-transparent tw-py-0 tw-pl-[25px] tw-text-[#0D8AE3] md:tw-mt-[20px]",
		expandBenefitsContent:
			"tw-text-[16px] tw-font-semibold tw-leading-[24px] tw-pt-[2px]",
		expandButtonIcon: "tw-ml-[8px] tw-text-[24px] tw-rotate-90",
	},
	socialProof: {
		wrapper:
			"tw-hidden tw-relative desktop:tw-flex tw-w-full tw-mb-[12px] tw-justify-center tw-border-t tw-border-[rgba(88,102,126,0.10)] desktop:tw-max-w-fit desktop:tw-bg-white desktop:tw-rounded-lg desktop:tw-p-2 desktop:[filter:drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] desktop:after:tw-absolute desktop:after:tw-right-[calc(50%-6px)] desktop:after:tw-w-2.5 desktop:after:tw-h-2.5 desktop:after:tw-translate-x-0 desktop:after:tw--translate-y-2/4 desktop:after:tw-rotate-45 desktop:after:tw-bg-white desktop:after:tw-overflow-hidden desktop:after:tw-pointer-events-none desktop:after:tw-bottom-[-8px]",
		contentWrapper:
			"tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2",
		contentIcon: "tw-text-[#0D8AE3] tw-text-[20px] md:tw-text-[32px]",
		content:
			"tw-leading-[12px] tw-font-semibold tw-text-[12px] tw-text-[#232227] tw-pt-[4px] md:tw-leading-[16px] tw-m-0 desktop:tw-max-w-[110px] ",
	},
	reviewLink: {
		wrapper:
			"tw-mt-[16px] tw-ml-[-8px] tw-flex tw-cursor-pointer tw-items-center tw-gap-[8px] tw-text-[#0D8AE3] hover:tw-underline tw-underline-offset-8 hover:tw-underline-offset-4 tw-transition-all desktop:tw-ml-0",
		text: "tw-text-[16px] tw-pt-[2px] tw-font-semibold tw-leading-[22px] desktop:tw-leading-[24px]",
	},
});
